// extracted by mini-css-extract-plugin
export default {"icon-button":"icon-button--fBT0R"};